import { useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import styles from "./styles.module.css";

const ResetPassword = () => {
    const { token } = useParams();
    const [password, setPassword] = useState("");
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const apiUrl = process.env.REACT_APP_API_BASE_URL;

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const res = await axios.post(`${apiUrl}/api/auth/reset-password/${token}`, { password });
            setMessage(res.data.message);
            setError("");
        } catch (err) {
            setError(err.response?.data?.error || "Bir hata oluştu");
            setMessage("");
        }
    };

    return (
        <div className={styles.reset_password_container}>
            
            <form className={styles.form_container} onSubmit={handleSubmit}>
                
                <h1>Yeni Şifre Belirleyin</h1>
                <input
                    type="password"
                    placeholder="Yeni şifrenizi girin"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    className={styles.input}
                />
                {message && <div className={styles.success_msg}>{message}</div>}
                {error && <div className={styles.error_msg}>{error}</div>}
                <button type="submit" className={styles.green_btn}>
                    Şifreyi Güncelle
                </button>
                
            </form>
        </div>
    );
};

export default ResetPassword;
